import {Injectable} from '@angular/core';

@Injectable()
export class MultilineFormatter {

    public format(value: string): string[] {
        return value ? value.toString().split(/\r?\n/) : [];
    }
}